//Library imports
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import { CookiesProvider } from 'react-cookie';

// Main CSS Rules
import './fonts.css'
import './generic.css'
import './specific.css'

import DepotAccess from './DepotAccess/DepotAccess.jsx';
import NoAccessContainerViewer from './DepotAccess/NoAccessContainerViewer.jsx'
import CodeAccess from './DepotAccess/CodeAccess.jsx';
import Terms from './Terms.jsx';
import Privacy from './Privacy.jsx';
import Failed from './Failed.jsx';
import config from './config.js';
import useScript from './DepotAccess/UseScript.js'

const Scripts = () => {
  useScript(`https://maps.googleapis.com/maps/api/js?key=${config.maps_api_key}&libraries=places&callback=initMap`, true, true);
  useScript(`https://www.google.com/recaptcha/api.js?render=${config.recaptcha_site_key}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <Scripts />
  <CookiesProvider>
    <Router>
      <Routes>
        <Route 
          path='/access/:locationGUID' 
          element={<DepotAccess/>}/>
        <Route 
          path='/access-no-login/:locationGUID' 
          element={<NoAccessContainerViewer/>}/>
        <Route 
          path='/privacy' 
          element={<Privacy/>}/>
        <Route 
          path='/termsofentry' 
          element={<Terms/>}/>
        <Route 
          path='/failed' 
          element={<Failed/>}/>
        <Route 
          path='/code-access/:locationGUID/:code' 
          element={<CodeAccess/>}/>
      </Routes>
    </Router>
  </CookiesProvider>
  </>
);